module.exports = __webpack_public_path__ + "img/tokyo-sauna-collapse.344beca2.png";